import { ComponentStyle } from '../../../models';

export class AccordionPanelConfig {
  isOpen: boolean;
  style: ComponentStyle;
  disabled: boolean;

  constructor({
    isOpen = false,
    style = ComponentStyle.Default,
    disabled = false
  } = {}) {
    this.isOpen = isOpen;
    this.style = style;
    this.disabled = disabled;
  }
}
